<template>
	<div>
		<div class="top-view">
			<a-card style="width: 70%;" :bordered="false" title="项目统计">
				<div class="card-view">
					<div class="card-item" @click="orderTypeClick(1)">
						<div class="left-item">
							<div class="num">{{staticsForm.allCount}}</div>
							<div class="title">项目总数</div>
						</div>
						<div class="right-item right-item1">
							<img src="@/assets/allCount.png" alt="">
						</div>
					</div>
					<div class="card-item" @click="orderTypeClick(2)">
						<div class="left-item">
							<div class="num">{{staticsForm.receivedCount}}</div>
							<div class="title">已收货项目数</div>
						</div>
						<div class="right-item right-item2">
							<img src="@/assets/receivedCount.png" alt="">
						</div>
					</div>
					<div class="card-item" @click="orderTypeClick(3)">
						<div class="left-item">
							<div class="num">{{staticsForm.unReceivedCount}}</div>
							<div class="title">未收货项目数</div>
						</div>
						<div class="right-item right-item3">
							<img src="@/assets/unreceived‌Count.png" alt="">
						</div>
					</div>
					<div class="card-item">
						<div class="left-item">
							<div class="num">{{staticsForm.receivedRatio}} <span>%</span></div>
							<div class="title">收货率</div>
						</div>
						<div class="right-item right-item4">
							<img src="@/assets/receivedRatio.png" alt="">
						</div>
					</div>
				</div>
			</a-card>
			<a-card style="width: 28%;" :bordered="false" title="代办事项">
				<div class="card-view">
					<div class="card-item1" @click="orderTypeClick(4)">
						<div class="num">{{staticsForm.newDevelopedCount}}</div>
						<div class="title">开发完成<img class="newImg" v-if="staticsForm.newDevelopedCount>0" src="@/assets/new.png" alt="" width="30"></div>
					</div>
					<div class="card-item1" @click="orderTypeClick(5)">
						<div class="num">{{staticsForm.newRepairedCount}}</div>
						<div class="title">返修完成<img class="newImg" v-if="staticsForm.newRepairedCount>0" src="@/assets/new.png" alt="" width="30"></div>
					</div>
				</div>
			</a-card>
			<a-card class="card-box" style="width: 100%;margin: 20px 0 0;" :bordered="false" title="账号项目统计">
				<div ref="chart1" class="charts" />
			</a-card>
		</div>
	</div>
</template>

<script>
	import {
		statics,
		staticsSub
	} from '@/api/order/statics'
	import * as echarts from 'echarts'
	export default {
		data() {
			return {
				staticsForm: {},
				staticsList: [],
				chartData1: []
			}
		},
		created() {
			this.getStatics()
		},
		methods: {
			orderTypeClick(type) {
				if(type==1) {
					this.$router.push('/project')
				}else if(type==2) {
					this.$router.push('/project?confirmFlag=1')
				}else if(type==3) {
					this.$router.push('/project?confirmFlag=2')
				}else if(type==4) {
					this.$router.push('/project?stageName=1')
				}else if(type==5) {
					this.$router.push('/project?stageName=2')
				}
			},
			getStatics() {
				statics().then(res => {
					this.staticsForm = res.data[0]
					this.getStaticsSub()
				})
			},
			getStaticsSub() {
				staticsSub().then(res => {
					this.staticsList = res.data
					this.chartData1 = this.staticsList.map(item=>{
						let arr = [item.name, item.receivedCount, item.unReceivedCount, Calculate(item.receivedCount, item.allCount), item.allCount]
						return arr
					})
					this.$nextTick(() => {
					  this.initChart1()
					});
					function Calculate(a, b) {
						return Number(( a / b  * 100).toFixed(2))
					}
				})
			},
			initChart1() {
				const chart1 = echarts.init(this.$refs.chart1)
				let option = {
					color: ['#0083E6', '#91CC75', '#FF856C', '#33D1FF'],
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['name', '已收货', '未收货', '收货率(%)', '项目总数']
					},
					dataset: {
						// source: [
						//   ['product', '2015', '2016', '2017'],
						//   ['Matcha Latte', 43.3, 85.8, 93.7],
						//   ['Milk Tea', 83.1, 73.4, 55.1],
						//   ['Cheese Cocoa', 86.4, 65.2, 82.5],
						//   ['Walnut Brownie', 72.4, 53.9, 39.1]
						// ]
						source: [
							['name', '已收货', '未收货', '收货率(%)', '项目总数'],
							...this.chartData1
						]
					},
					xAxis: {
						type: 'category',
						name: '名称',
						axisLabel: {
							rotate: 40,
						}
					},
					yAxis: {
						name: '数量'
					},
					dataZoom: [{
							type: 'slider',
							show: true,
							xAxisIndex: [0],
							start: 0,
							end: 50,
						},
						{
							type: 'inside',
							xAxisIndex: [0],
							start: 0,
							end: 10,
						}
					],
					series: [{
							type: 'bar',
							itemStyle: { //上方显示数值
								normal: {
									label: {
										show: false, //开启显示
										position: 'top', //在上方显示
										textStyle: { //数值样式
											color: 'black',
											fontSize: 24,
											fontWeight: 'bold'
										}
									}
								}
							}
						},
						{
							type: 'bar',
							itemStyle: { //上方显示数值
								normal: {
									label: {
										show: false, //开启显示
										position: 'top', //在上方显示
										textStyle: { //数值样式
											color: 'black',
											fontSize: 24,
											fontWeight: 'bold'
										}
									}
								}
							}
						},
						{
							type: 'bar',
							itemStyle: { //上方显示数值
								normal: {
									label: {
										show: false, //开启显示
										position: 'top', //在上方显示
										textStyle: { //数值样式
											color: 'black',
											fontSize: 24,
											fontWeight: 'bold'
										}
									}
								}
							}
						},
						{
							type: 'bar',
							itemStyle: { //上方显示数值
								normal: {
									label: {
										show: false, //开启显示
										position: 'top', //在上方显示
										textStyle: { //数值样式
											color: 'black',
											fontSize: 24,
											fontWeight: 'bold'
										}
									}
								}
							}
						}
					]
				}

				chart1.setOption(option)
			},
		}
	}
</script>

<style lang="scss">
	.top-view {
		display: flex;
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;

		.card-box {
			.ant-card-head {
				text-align: center;
			}

			.charts {
				width: 100%;
				height: 500px;
			}
		}

		.ant-card-head {
			border: none;
			color: #000;
			font-weight: bold;
			font-size: 22px;
		}

		.ant-card-body {
			padding: 0 20px 20px;
		}

		.card-view {
			display: flex;
			width: 100%;
			justify-content: space-between;

			.card-item {
				width: calc(25% - 10px);
				background: #FAFAFC;
				padding: 20px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				cursor: pointer;

				.left-item {
					display: flex;
					flex-direction: column;
					align-items: left;

					.num {
						color: #000;
						font-size: 28px;
						font-weight: bold;
						padding: 0 0 10px;
						span {
							color: #666;
							font-size: 20px;
						}
					}

					.title {
						color: #929292;
						font-size: 15px;
					}
				}

				.right-item {
					width: 60px;
					height: 60px;
					padding: 12px 15px;
					border-radius: 5px;

					img {
						width: 100%;
					}
				}

				.right-item1 {
					background: #BDD7FE;
				}

				.right-item2 {
					background: #E6F4E0;
				}

				.right-item3 {
					background: #FFE1DB;
				}

				.right-item4 {
					background: #DFF5FF;
				}
			}
			.card-item:nth-of-type(4n) {
				cursor: auto;
			}

			.card-item1 {
				width: 50%;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 20px 0 0;
				cursor: pointer;

				.num {
					color: #0083E6;
					font-size: 30px;
					font-weight: bold;
					padding: 0 0 10px;
				}

				.title {
					color: #929292;
					font-size: 15px;
					display: flex;
					align-items: center;
					
					.newImg {
						opacity: 1;
						animation: fadeIn 2s linear 2s infinite;
						margin: 0 0 0 6px;
					}
					
					
				}
			}
		}
	}
	@keyframes fadeIn {
		to {
			opacity: .5;
		}
	
		from {
			opacity: 1;
		}
	}
</style>